import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Container } from '../Container'

export const HowItWorksGreenCheckSection: React.FC<{
  first?: GreenCheckHowItWorksProps
  second?: GreenCheckHowItWorksProps
  third?: GreenCheckHowItWorksProps
  title?: string
  locale?: 'en' | 'es'
}> = ({ first, second, third, title, locale = 'en' }) => {
  const defaultCopy =
    locale === 'es'
      ? {
          title: '¿Por qué NuBrakes?',
          first: {
            title: 'Vamos a ti',
            subtitle:
              'Nuestros técnicos móviles ofrecen reparaciones de frenos con excelentes calificaciones en tu casa u oficina por hasta 40% menos que un taller.',
          },
          second: {
            title: 'Mejores precios',
            subtitle:
              'En promedio somos 40% más accesibles que concesionarios y talleres, así que ahorras tiempo y dinero.',
          },
          third: {
            title: 'Disponibilidad el mismo día',
            subtitle:
              '¿Necesitas reparar tus frenos hoy? Normalmente hay servicio el mismo día — contáctanos para agendar.',
          },
        }
      : {
          title: 'Why NuBrakes?',
          first: {
            title: 'We Come To You',
            subtitle:
              'Our mobile brake techs deliver top-rated brake repairs at your home or office for up to 40% less than a repair shop.',
          },
          second: {
            title: 'Better Prices',
            subtitle:
              "We're 40% more affordable on average compared to the dealerships and shops so you'll be saving time and money.",
          },
          third: {
            title: 'Same-Day Availability',
            subtitle: 'Need your brakes repaired today? Same-day service is typically available — contact us to schedule!',
          },
        }

  const resolvedTitle = title ?? defaultCopy.title
  const resolvedFirst = first ?? defaultCopy.first
  const resolvedSecond = second ?? defaultCopy.second
  const resolvedThird = third ?? defaultCopy.third
  return (
    <section>
      <Container>
        <div className="text-center mb-5">
          <h2>{resolvedTitle}</h2>
        </div>
        <div className="grid md:grid-cols-3">
          <GreenCheckHowItWorks {...resolvedFirst} />
          <GreenCheckHowItWorks {...resolvedSecond} />
          <GreenCheckHowItWorks {...resolvedThird} />
        </div>
      </Container>
    </section>
  )
}

type GreenCheckHowItWorksProps = {
  title: string
  subtitle: string
}
const GreenCheckHowItWorks: React.FC<GreenCheckHowItWorksProps> = ({ title, subtitle }) => {
  return (
    <div className="flex flex-row">
      <div className={'mr-2'}>
        <FontAwesomeIcon icon={faCheckCircle} style={{ fontWeight: 100 }} size={'2x'} color={'#14d90d'} />
      </div>
      <div>
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </div>
    </div>
  )
}
